import { IDropdownOption } from "../shared.types";

export const getDropdownText = (key: string, options: IDropdownOption[]) => {
    const selectedOption = options.find(x => x.key == key);
    return selectedOption ? selectedOption.text : "";
}